/**
 * Render widget theo widget_type. Map từ payload → React component.
 */
import { Card } from "@/components/ui/card";
import type { Uuid, WidgetType } from "@/types";

import { ConfirmationCard } from "./ConfirmationCard";
import { DataTableWidget } from "./DataTableWidget";
import { DynamicForm } from "./DynamicForm";

interface WidgetRendererProps {
  widgetId: Uuid;
  widgetType: WidgetType;
  payload: Record<string, unknown>;
  onSubmit?: (data: Record<string, unknown>) => void;
  onApproval?: (
    action: "save" | "cancel" | "approve" | "reject" | "request_change",
    reason?: string,
  ) => void;
  status?: "pending" | "submitted" | "approved" | "rejected";
}

export function WidgetRenderer(props: WidgetRendererProps): JSX.Element {
  switch (props.widgetType) {
    case "dynamic_form":
      return (
        <DynamicForm
          payload={props.payload as never}
          status={props.status}
          onSubmit={props.onSubmit}
          onCancel={() => props.onApproval?.("cancel")}
        />
      );
    case "confirmation_card":
      return (
        <ConfirmationCard
          payload={props.payload as never}
          status={props.status}
          onApproval={props.onApproval}
        />
      );
    case "data_table":
      return <DataTableWidget payload={props.payload as never} />;
    default:
      return (
        <Card className="p-3 text-xs text-muted-foreground">
          Widget <code>{props.widgetType}</code> sẽ render ở phase sau.
        </Card>
      );
  }
}
